<app-page-wrapper>
    <app-loading-spinner *ngIf="!(loaded.report && loaded.students && loaded.class); else main"></app-loading-spinner>
    <ng-template #main>
        <div class="my-4">
            <span class="link breadcrumb-link" (click)="goBack()">
                <i class="far fa-angle-left"></i> Back
            </span>
        </div>
        <div>
            <div class="d-flex align-items-end my-4 assignment-header-background">
                <h1 class="m-0 mr-2">
                    Assignment Report: 
                </h1>
                <h2>
                    <i [class]="iconClasses"></i>
                    {{currentAssignment.ActivitySequence.Name}}
                </h2>
            </div>
            <div>
                <div class="row header my-4">
                    <div class="col-md-4 mb-4">
                        <div class="detail-name" style="font-size: x-large;">Class Name: </div>
                        <div>
                            {{class.Description}}
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="detail-name">Class Code</div>
                        <div class="detail-value">{{class.LoginCode}}</div>
                    </div>
                    <div class="d-flex align-items-end col-md-4 header">
                        <div class="ml-auto align-self-start no-print">
                            <a *ngIf="class" (click)="printPage()" ngbTooltip="Print">
                                <i class="fal fa-print pointer"></i>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="detail-name">Assigned On</div>
                        <div class="detail-value">{{longDateFormat(currentAssignment.StartDate)}}</div>
                    </div>
                    <div class="col-md-4">
                        <div class="detail-name">Percent Complete</div>
                        <div class="detail-value">{{percentComplete}}%</div>
                    </div>
                </div>
            </div>
        </div>
        <table class="table">
            <thead>
                <th class="first-column">Student Name</th>
                <th *ngFor="let columnId of columnIds">
                    <span>{{columnHeader1(columnId)}}</span>
                    <br>
                    <span>{{columnHeader2(columnId)}}</span>
                </th>
            </thead>
            <tbody>
                <tr *ngFor="let student of assignedStudents">
                    <td class="first-column">
                        {{student.Name}}
                    </td>
                    <td *ngFor="let columnId of columnIds">
                        {{studentColumns[student.ID][columnId] ? longDateFormat(studentColumns[student.ID][columnId]) : '--'}}
                    </td>
                </tr>
            </tbody>
        </table>
    </ng-template>
</app-page-wrapper>